var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Link = require('react-router').Link;
var LinkWrapper = require('../../../components/linkWrapper.jsx')(Link);

var SurveyEntryMyGiHistory = createReactClass({
    mixins: [PureRenderMixin],

    render: function(){
        var labelText = this.props.labelText || "Complete the Gi History Survey";
        var className = 'survey-entry button ' + (this.props.className || '');

        return (
            <LinkWrapper
                className={className}
                to="/dashboard/surveys/gihistory"
                action={labelText}
                handler={this.props.clickTracking}>
                {labelText}
            </LinkWrapper>
        )
    }
});

module.exports = SurveyEntryMyGiHistory;



// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/layout/surveyEntryMyGiHistory.jsx